module.exports = __webpack_public_path__ + "static/media/tngCard.78d2a6ff.png";